module.exports = __webpack_public_path__ + "static/media/walkthrough_men.7d665674.svg";